import { BehaviorParameters } from 'rangeConfig/@types';
import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { addTopPanelsToFrameGroup, getFrameGroupForTop } from '../utils/topPanels';
import { ProductType } from '@inter-ikea-storageone/range';

const addTopPanelToFrame = ({
  coreApi,
  props,
  rootState: {
    products: { inMarket: products }
  }
}: BehaviorParameters) => {
  const productId = props.coreProductIds ? props.coreProductIds[0] : props.coreProductId;
  const topPanelInCard = products.find(p => p.coreProductId === productId);
  const topPanelsToAdd = products.filter(
    p => p.design === topPanelInCard?.design && p.type === topPanelInCard?.type
  );

  const frame = props.position
    ? coreApi.entities.getEntityAtPosition(props.position, [ComponentIds.FRAME_COMPONENT_ID])
    : coreApi.entities.findSelectedEntity();

  if (!frame || topPanelsToAdd.length === 0) {
    return;
  }
  if (topPanelInCard && topPanelInCard?.type === ProductType.BESTA_TOP_PANEL_TV_BENCH) {
    const currentTop = HierarchyUtils.descendants(frame).find(child =>
      coreApi.entities.isProductType(child, ProductType.BESTA_TOP_PANEL_TV_BENCH)
    );
    currentTop && coreApi.entities.delete(currentTop);
    coreApi.products.addToTarget(topPanelInCard.coreProductId, frame);
  } else {
    const frameGroup = getFrameGroupForTop(frame, coreApi);
    addTopPanelsToFrameGroup(frameGroup, topPanelsToAdd, coreApi);
  }
};

export default addTopPanelToFrame;
